import React, { ButtonHTMLAttributes } from "react";
import css from "./Button.module.scss";
import { getClassName } from "@utils";

export enum ButtonVariant {
  Default = "Default",
  Primary = "Primary",
  Secondary = "Secondary",
  Error = "Error",
}

export enum ButtonSize {
  XS = "Xs",
  S = "S",
  M = "M",
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = ButtonVariant.Default,
  size = ButtonSize.M,
  className,
  disabled = false,
  type = "button",
  onClick,
  ...rest
}) => {
  const attrs = {
    button: {
      className: getClassName(css.button, css[`button${variant}`], css[`button${size}`], className),
      disabled,
      type,
      onClick,
      ...rest,
    },
  };

  return <button {...attrs.button}>{children}</button>;
};

export default Button;
